// src/components/ToolsMenu.js
import * as React from 'react';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FolderZipRoundedIcon from '@mui/icons-material/FolderZipRounded';
import SimCardDownloadRoundedIcon from '@mui/icons-material/SimCardDownloadRounded';

import * as WrcCommon from '@webrcade/app-common';

import { openManifestDialog } from './cloud/generate-manifest/GenerateManifestDialog';
import { openRepackageDialog } from './tools/repackage/RepackageDialog';

// 🔹 i18n
import { useI18n } from '../i18n/I18nContext';

export default function ToolsMenu(props) {
  const { anchorEl, setAnchorEl, setOpen } = props;
  const isOpen = Boolean(anchorEl);

  const { t } = useI18n(); // 🔹 Hook de tradução

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      placement="right-start"
      onClose={handleClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "center",
      }}
    >

      {/* 🔧 Repackage Archive... */}
      <MenuItem
        onClick={() => {
          openRepackageDialog();
          setOpen(false);
          handleClose();
        }}
      >
        <ListItemIcon>
          <FolderZipRoundedIcon />
        </ListItemIcon>
        {t("toolsMenuRepackageArchive")}
      </MenuItem>

      {/* Apenas se cloud estiver habilitado */}
      {WrcCommon.settings.isCloudStorageEnabled() && <Divider />}

      {/* 🧩 Generate Package Manifest File... */}
      {WrcCommon.settings.isCloudStorageEnabled() && (
        <MenuItem
          onClick={() => {
            openManifestDialog();
            setOpen(false);
            handleClose();
          }}
        >
          <ListItemIcon>
            <SimCardDownloadRoundedIcon />
          </ListItemIcon>
          {t("toolsMenuGenerateManifest")}
        </MenuItem>
      )}

    </Menu>
  );
}